import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Login } from './login/Login';
import { RegisterBrand } from './register/brand';
import { RegisterEmployee } from './register/employee';
import { RegisterAgency } from './register/agency';
import { InfluencerRegisterPage } from './register/influencer/InfluencerRegisterPage';
import ForgotPassword from './forgot';
import { shallowEqual, useSelector } from 'react-redux';
import { IAllStates } from '../store/rootReducer';
import { VerificationPage } from './verification/VerificationPage';
import RegisterGlobalDiscovery from './register/global-discovery';

export function AuthRoutes() {
    const { isAuthorized } = useSelector(
        (state: IAllStates) => ({
            isAuthorized: !!state.auth.user,
        }),
        shallowEqual
    );

    return (
        <Routes>
            <Route path="/brand/register/:stepId" element={<RegisterBrand />} />
            <Route path="/brand/employee/register/:stepId" element={<RegisterEmployee />} />
            <Route path="/agency/register/step/:stepId" element={<RegisterAgency />} />
            <Route path="/global-discovery/register/step/:stepId" element={<RegisterGlobalDiscovery />} />

            <Route path="/influencer/agency/register/1" element={<Navigate to="/agency/register/step/1" replace />} />

            <Route path="/influencer/register/step/:stepId" element={<InfluencerRegisterPage />} />
            <Route path="/auth/password/reset" element={<ForgotPassword />} />

            {isAuthorized && <Route path="/verification-page/:id?" element={<VerificationPage />} />}

            {/* <Route
                path="/impersonate/:token/:id/:isAdmin/:adminActiveFirstRoute?/:adminActiveSecondRoute?/:adminActiveThirdRoute?"
                element={<Impersonate />}
            /> */}
            <Route path="/auth/login" element={<Login />} />
            <Route path="/" element={<Login />} />
            <Route path="*" element={<Login />} />
        </Routes>
    );
}
